<template>
  <div class="page-contact-menu" :class="{'mobile-only' : $props.mobileOnly}">
    <ul role="menu">
      <li role="menuitem" v-for="item in contactMenu" :key="'contact-'+item.name">
        <h4>{{ item.title }}</h4>
        <a :href="item.link" :target="item.target">{{ item.description }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import { contactMenu } from './config/contactMenuConfig'

export default {
  name: 'page-contact-menu',
  props: {
    mobileOnly: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    contactMenu () {
      return Object.freeze(contactMenu)
    }
  }
}
</script>

<style scoped lang="scss">
.page-contact-menu {
  background-color: $white;
  box-shadow: $shadow;
  color: $text;
  border-radius: 5px;

  ul {
    padding: 1.2rem;
    margin: 0;
    display: flex;
    flex-wrap: wrap;

    @media (map_get($breakpoints, exsm)) {
      justify-content: space-evenly;
      flex-wrap: nowrap;
    }

    li {
      padding: 1.2rem;

      &:first-child {
        margin-right: auto;

        @media (map_get($breakpoints, exsm)) {
          margin-right: 0;
        }
      }

      &:last-child {
        min-width: 100%;

        @media (map_get($breakpoints, exsm)) {
          min-width: auto;
        }
      }

      h4 {
        font-size: 1.6rem;
        margin: 0;
        white-space: nowrap;
      }

      p, a {
        font-size: 1.4rem;
        color: $dark-grey;
        margin: 0;
        outline: none;
        text-decoration: none;
        white-space: nowrap;
      }
    }
  }

  &.mobile-only {
    @media (map_get($breakpoints, md)) {
      display: none;
    }
  }
}
</style>
